<template>
    <router-view />
    <TooltipProvider />
</template>

<script>
import { watch, onBeforeUnmount } from "vue";
import { useUserStore } from "@/stores/userStore";
import { useDashboardStore } from "@/stores/dashboardStore";
import { wsService } from "@/services/websocket";
import TooltipProvider from '@/components/elements/TooltipProvider.vue'

export default {
    components: {
        TooltipProvider
    },    
    setup() {
        const userStore = useUserStore();
        const dashboardStore = useDashboardStore();

        // Функция подключения к WebSocket
        const connectWebSocket = () => {
            if (userStore.isAuthenticated && !wsService.isConnected.value) {
                console.log("[App] Connecting WebSocket...");
                wsService.connect();
            }
        };

        // Функция отключения
        const disconnectWebSocket = () => {
            if (wsService.isConnected.value) {
                console.log("[App] Disconnecting WebSocket...");
                wsService.disconnect();
            }
        };

        // Следим за состоянием авторизации
        const unwatchAuth = watch(
            () => userStore.isAuthenticated,
            (isAuth) => {
                if (isAuth) {
                    connectWebSocket();
                } else {
                    disconnectWebSocket();
                    dashboardStore.reset();
                }
            },
            { immediate: true }
        );

        // Отключаемся при уничтожении приложения (например, при hot-reload или закрытии вкладки)
        onBeforeUnmount(() => {
            unwatchAuth();
            disconnectWebSocket();
        });
    },
};
</script>
